<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm10 md8 lg6>
      <v-card class="elevation-12" align-center justify-center>
        <v-toolbar dark color="primary">
        </v-toolbar>
        <v-img
          src="/static/img/logo.png"
          height="250"
          contain
          pt-5
        ></v-img>

        <div class="headline text-xs-center mb-4">Volunteer Handbook Acceptance</div>

        <div v-if="saved">
          <div class="headline mx-4">
            <p>Thank You!.</p>
          </div>
        </div>
        <div v-else>
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
          <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <div class="headline mx-4">
                      Please download and review the <a href="https://front.rrride.com/api/documents/Volunteer_Handbook.pdf" target="_blank">Reno Rodeo Volunteer Handbook</a>.
                    </div>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.firstName"
                      label="First Name"
                      :rules="[v => !!v || 'First Name is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.lastName"
                      label="Last Name"
                      :rules="[v => !!v || 'Last Name is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                <v-flex xs12 md8>
                    <v-text-field
                      label="Email"
                      type="email"
                      v-model="editedItem.email"
                      :rules="emailRules"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <div class="headline mx-4">
                      By checking the “I agree” box below, I acknowledge that I have received and read the Volunteer Handbook, understand its contents, and agree to follow the terms and conditions outlined.
                    </div>
                  </v-flex>
                  <v-flex xs12>
                    <div class="headline mx-4">
                      I understand that failure to follow the policies and procedures as outlined may result in my removal from the Reno Rodeo Association as stated in the Bylaws Article III Membership, Section G – Removal.
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            <v-alert :value="error" type="warning" transition="scale-transition">
              <span v-html="error"></span>
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-checkbox
                v-model="checkbox"
                label="I agree!"
                :rules="[v => !!v || 'You must agree to continue!']"
                required
              ></v-checkbox>
              <v-btn color="primary" @click="save">Accept</v-btn>
          </v-card-actions>
        </v-form>
        </div>
      </v-card>
    </v-flex>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import moment from 'moment'

export default {
  data () {
    return {
      valid: true,
      currentYear: 0,
      checkbox: false,
      saved: false,
      mobileTypes: [],
      editedItem: {},
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      error: null,
      snackbar: {
        show: false,
        color: '',
        message: ''
      }
    }
  },

  created () {
    this.getDate()
    this.getMobileTypes()
  },

  methods: {
    getDate () {
      let currentYear = moment().format('YYYY')
      let nextYear = moment()
        .add(1, 'years')
        .format('YYYY')
      let currentDate = moment().format('MM')

      if (currentDate >= 7) {
        this.currentYear = nextYear
      } else {
        this.currentYear = currentYear
      }
    },

    async getMobileTypes () {
      try {
        const response = await Api().get('mobiletypes')
        this.mobileTypes = response.data
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async save () {
      try {
        this.editedItem.year = this.currentYear

        if (this.$refs.form.validate()) {
          await Api().post('handbook', this.editedItem)
          this.editedItem = {}

          this.saved = true
        } else {
          this.snackbar.message = 'You have some errors on the page!'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/handbook/ExternalForm.vue